module.exports = __webpack_public_path__ + "img/vue1-arriere_bleu.42ad349a.png";